import { render, staticRenderFns } from "./Xiami.vue?vue&type=template&id=2056e4fe"
import script from "./Xiami.vue?vue&type=script&setup=true&lang=js"
export * from "./Xiami.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports